var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['simple_button', { 'disabled_button': _vm.disabled },
    { 'empty_classification_button': _vm.clasificar },
    _vm.classification ? [_vm.getButtonStyle(_vm.classiValue), 'classi_button', _vm.skew(_vm.classiValue)] : ''],style:(_vm.computedStyle),on:{"click":function($event){return _vm.onButtonClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }